const SubscriptionResponseText={
    modalText:
    {
        en:"Click on the button below",
        fr:"Cliquez sur le bouton ci-dessous"
    },
    noMsisdnFoundText:
    {
        en:"Kindly enable user mobile data to access this service",
        fr:"Veuillez activer les données mobiles de l'utilisateur pour accéder à ce service"
    },
    rechargeAgainText:
    {
       en:"Click and try again later by dialing",
       fr:"Rechargez et réessayez plus tard en composant le"
    },
    buttonText:
    {
        en:"Click here",
        fr:"Cliquez ici"
    },
    orText:
    {
        en:"or",
        fr:"Ou"
    },
    retryBtnText:
    {
      en:"Retry",
      fr:"Réessayer"
    },
    shortCodeText:{
      en:"8093",
      fr:"8093"
    },
    dialText:
    {
        en:"Dial",
        fr:"Composer le"
    },
    dialMsgText:
    {
        en:"<Friend Number> to have fun with Magic Voice",
        fr:"<Numéro de l'ami> pour vous amuser avec Magic Voice."
    },
    subPackText:
    {
        en:"This unique service let's you change your voice on call.Activate and let the fun begin!",
        fr:"Ce service unique vous permet de changer votre voix pendant un appel. Activez-le et que le plaisir commence !"
    },
    okButtonText:{
       en:"Ok",
       fr:"OK"
    },
    packsText:
    [
        {
            id:1,
            packTitle:
            {
                en:"Daily Pack",
                fr:"Forfait quotidien"
            },
            packType:"daily",
            pricePointText:
            {
                en:"200 GNF",
                fr:"200 GNF"
            },
            oKText:{
                en:"OK",
                fr:"OK"
            }
        },
        {
            id:2,
            packTitle:
            {
                en:"Weekly Pack",
                fr:"Forfait hebdomadaire"
            },
            packType:"weekly",
            pricePointText:
            {
                en:"1250 GNF",
                fr:"1250 GNF"
            },
            oKText:{
                en:"OK",
                fr:"OK"
            }
        },
        {
            id:3,
            packTitle:
            {
                en:"Monthly Pack",
                fr:"Forfait Mensuel"
            },
            packType:"monthly",
            pricePointText:
            {
                en:"2500 GNF",
                fr:"2500 GNF",
            },
            oKText:{
                en:"OK",
                fr:"OK"
            }
        }
    ]
};
const SideMenuText=[
           {
            title:{
                en:"Account",
                fr:"Compte"
            },
            id:1,
            link:"/account"
           },
           {
            title:{
                en:"Language",
                fr:"Langue"
            },
            id:2,
            link:"/language"
           },
];
const modalText={
    failureText:{
        en:"Sorry! due to some technical issue your request could not be processed",
        fr:"Désolé ! En raison d'un problème technique, votre demande n'a pas pu être traitée",
    },
    successText:
    {
        en:"Activation Successful",
        fr:"Activation réussie"
    },
   confirmModalText:
   {
        en:"Please Confirm to Subscribe",
        fr:"Veuillez confirmer votre abonnement"
   },
   lowBalanceText:
   {
    en:"Oops!You have insufficient balance",
    fr:"Oups ! Vous avez un solde insuffisant"
   },
   subsribedUserText:
   {
    en:"You are already subscribed",
    fr:"Vous êtes déjà abonné(e)"
   }
}
export {SubscriptionResponseText,SideMenuText,modalText};